import { DashboardConstants } from '../../actions/constant';

const {
  GET_THERAPIST_DAILY_UPDATES_REQUEST,
  GET_THERAPIST_DAILY_UPDATES_SUCCESS,
  GET_THERAPIST_DAILY_UPDATES_FAILURE,
  GET_THERAPIST_DAILY_UPDATES_RESET,
} = DashboardConstants;

const initialstate: object = {
  response: null,
  loading: false,
};

export const therapistDailyUpdatesReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPIST_DAILY_UPDATES_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_THERAPIST_DAILY_UPDATES_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case GET_THERAPIST_DAILY_UPDATES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_THERAPIST_DAILY_UPDATES_RESET:
      return initialstate;

    default:
      return state;
  }
};
